import React, { Component } from 'react';
import Button from '../Button';
import './Options.css';

class Options extends Component {
  constructor(context, props) {
    super(context, props);
    this._options = [];
    let { options } = this.props;
    let falseList = options.map(() => false);
    this.state = {chosen: '', animated: falseList};
  }

  componentDidMount() {
    let { options, setOptionsHeight } = this.props;
    const ANIMATION_DURATION = 1000;
    this.setState({...this.state, height: this._options[0].scrollHeight });
    setOptionsHeight(this._line.scrollHeight);
    options.forEach((opt, i) => {
      setTimeout(function() {
        let { animated } = this.state;
        animated[i] = true;
        this.setState({...this.state, animated});
      }.bind(this), 200 * i + ANIMATION_DURATION + 10);
    });
    setTimeout(function() {
      if (this.props.onAnimated) this.props.onAnimated();
    }.bind(this), 200 * (options.length - 1) + ANIMATION_DURATION);
  }

  handleSelect(text, index) {
    this.props.selectOption(text);
    this.setState({...this.state, chosen: text});
  }

  getOptionsLine(helper) {
    let { options } = this.props;
    let { chosen, height, animated } = this.state;
    let optionsStyle = chosen && !helper ? {height: height + 'px'} : {};
    return (
      <div className={"Options__line" + (chosen && !helper ? " Options__line--chat" : "") + (helper ? " Options__line--helper" : "")} style={optionsStyle} ref={(l) =>{this._line = l;}}>
        <div className="Options__left"></div>
        <div className="Options__content">
          {options.map((opt, i) => {
            let className = "Options__button";
            let buttonClassName = "";
            let style = {animationDelay: 0.2*i + 's'};
            let buttonStyle = {};
            if (height) {
              className += " Options__button--init";
            }
            if (animated[i]) {
              className += " Options__button--animated";
            }
            if (chosen) {
              if (chosen === opt.name) {
                if (helper) {
                  className += " Options__button--helper-chosen";
                } else {
                  className += " Options__button--chosen";
                  buttonClassName = "Bubble--you";
                }
              } else {
                if (helper) {
                  className += " Options__button--helper-hidden";
                } else {
                  className +=" Options__button--hidden"
                }
              }
            }
            return <div key={i} className={className} style={style} ref={(o)=> {this._options.push(o)}}>
                <Button className={buttonClassName} onClick={this.handleSelect.bind(this, opt.name, i)} style={buttonStyle}>
                  <span className="Options__button--full">{opt.name}</span>
                  <span className="Options__button--mobile">{opt.mobile_name}</span>
                </Button>
              </div>
          })}
        </div>
        <div className="Options__right"></div>
      </div>
    );
  }

  render() {
    return <div>
      {this.getOptionsLine.bind(this)(true)}
      {this.getOptionsLine.bind(this)()}
    </div>;
  }
}

export default Options;



/** WEBPACK FOOTER **
 ** ./src/components/Options/index.js
 **/